import { CaptureScreen } from "../design-system/shell/capture-screen";
import { Spinner } from "../design-system/primitives/spinner";
import { ActionButton } from "../design-system/concept/action-button";
import { ChevronForwardIcon, RefreshIcon } from "../design-system/shell/icons";
import { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../MyContext";
import "../theme/PhotoPreview.css";
import "../theme/Utilities.css";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { ImageResource, OrientResource } from "../lib/types";
import { orientationTransform } from '../lib/orientation-transform';
import  CameraOverlay  from "../components/scan/CameraOverlay";
import { uploadImage, AuthProvider } from "../lib/http-service"; 
import { ClientDataHolder } from "../lib/dashboard/data";
const PhotoCapture: React.FC = () => {
    const history = useHistory();
    //const auth = new AuthProvider(useAuth0().getAccessTokenSilently);
    const auth = new AuthProvider(()=>Promise.resolve("fix-ugly-later"), undefined, undefined, undefined, true);
    const { profileID, sessionID, gender, pose } = useParams<{ profileID: string, sessionID: string, gender: string, pose: 'front'|'right' }>();
    const [client] = useState<ClientDataHolder>(new ClientDataHolder(profileID, auth));
    const addResource = client.addResourceToSession;
    const getResource = client.getResourceFromSession;
   
    
    const [uploaded, setUploaded] = useState(false);

    const { setFrontMaskDone, setFrontImgDone } = useContext(Context);
    const [image, setImage] = useState<ImageResource>();
    const [objectMask, setObjectMask] = useState<ImageResource>();
    const [orientation, setOrientation] = useState<OrientResource>();
    const which = "ready";
    const [error, setError] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setImage(undefined)
        setObjectMask(undefined)
        setFrontImgDone(false)
        setFrontMaskDone(false)
        setUploaded(false)
    }, [pose])


    const fetchImage = async () => {
        let i = 0;
        while (i < 5) {
            try {
                let response = await  getResource(sessionID, `${pose}_img`);
                console.log("Fetched image", response);
                setImage(response);
                return;
            } catch (error: any) {
                console.error(error);
            }
            await new Promise((resolve) => setTimeout(resolve, 500));
            i++;
        }
    };

    const fetchMask = async () => {

        try {
            let response = await getResource(sessionID, `${pose}_mask`);
            setObjectMask(response);
            if (response.status === 200) return;
        } catch (error: any) {
            console.error(error);
        }
    };

    const fetchOrientation = async () => {
        try {
            let response = await getResource(sessionID, `${pose}_orient`);
            setOrientation(response);
            if (response.status === 200) return;
        } catch (error: any) {
            console.error(error);
        }
    };
    const optimizeImages = async () => {

        console.log("Optimizing images", which);
        let response = await addResource(sessionID,which, { createdBy: "app-alpha1" }, true);
        console.log("Optimizing images", response.status, response);
    };

    const maskTransform = useMemo(() => {
        return orientationTransform(orientation?.orient);
    }, [orientation]);

    const uploadPhoto = async (photo: string, orientation: any) => {
        setUploaded(true);
        setIsLoading(true);
        setError("");
       
        let response = await addResource(sessionID, `${pose}_angle`, { "beta": orientation.beta, "alpha": orientation.alpha, "gamma": orientation.gamma }, true);
        const imgResource = { pixels: photo.split(",")[1], createdBy: "pro" }
        response = await uploadImage(profileID, sessionID, pose, photo, gender, pose === 'front', auth);
        setUploaded(true);
        setImage({...imgResource, id:"temp", createdAt: new Date().toISOString()});
        
        const body = await response.json();
        setIsLoading(false);
        console.log("Photo taken", response.status, body);
        if (response.status >= 400) {
            const reason = body?.reason || body?.error || "Error uploading image, please retake photo";
            console.log("Upload rejected", response.status, reason);
            setError(reason);
            await fetchImage();
            return;
        }
        if (body.status === 'rejected') {
            const isDev = window.location.hostname.includes('dev') || window.location.hostname.includes('localhost');
            const reason = isDev
                ? (body.reason || "Image rejected")
                : "The photo could not be processed. Please retake the photo following the instructions.";
            console.log("Upload rejected by rembg:", body.reason, "backend:", body.backend);
            setError(reason);
            // Mask is still returned on rejection — show overlay
            if (body.pixels) {
                setObjectMask({ pixels: body.pixels, id: "rejected", createdAt: new Date().toISOString() });
                if (body.orient !== undefined) {
                    setOrientation({ orient: body.orient, id: "rejected", createdAt: new Date().toISOString() });
                }
            }
            return;
        }
        await Promise.all([fetchMask(), fetchOrientation()]);
        setIsLoading(false);

        setFrontMaskDone(true);
    }

    return (
        <CaptureScreen className="z-50" bare={!uploaded}>
            {!uploaded ? (
                <CameraOverlay
                    setUploaded={() => {}}
                    sessionID={sessionID}
                    profileID={profileID}
                    pose={pose}
                    gender={gender}
                    uploadPhoto={uploadPhoto}
                />
            ) : isLoading ? (
                <div className="flex flex-1 flex-col items-center justify-center gap-4">
                    <Spinner size={44} />
                    <p className="text-sm text-muted-foreground">Please wait…</p>
                </div>
            ) : (
                <div className="mx-auto flex w-full max-w-lg flex-col items-center gap-4 p-4">
                    <div className="relative">
                        <img
                            alt="The photograph just taken"
                            src={`data:image/png;base64,${image?.pixels}`}
                            className="rounded-lg"
                            style={{ width: 420, height: 420 }}
                        />
                        {objectMask?.pixels && (
                            <div className="absolute inset-0">
                                <img
                                    alt=""
                                    src={`data:image/png;base64,${objectMask?.pixels}`}
                                    style={{
                                        transform: `${maskTransform}`,
                                        width: 420,
                                        height: 420,
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    <div
                        className={`w-full rounded-lg border p-4 text-center text-sm ${
                            error.length > 0
                                ? 'border-[hsl(var(--projected-line))] bg-[hsl(var(--projected-bg))] text-[hsl(var(--projected))]'
                                : 'border-border bg-card'
                        }`}
                    >
                        {error.length > 0 ? (
                            error
                        ) : (
                            <>
                                Is the whole person highlighted? If not, retake the
                                photo.
                            </>
                        )}
                    </div>

                    <div className="flex w-full flex-wrap justify-center gap-2">
                        <ActionButton
                            className="flex items-center gap-2 px-5 py-3 text-sm"
                            onClick={() => {
                                setUploaded(false);
                                setFrontMaskDone(false);
                                setFrontImgDone(false);
                            }}
                        >
                            <span className="flex items-center gap-2">
                                Retake photo <RefreshIcon size={18} />
                            </span>
                        </ActionButton>

                        {!error &&
                            (pose === 'front' ? (
                                <ActionButton
                                    variant="primary"
                                    className="flex items-center gap-2 px-5 py-3 text-sm"
                                    onClick={() =>
                                        history.push(
                                            `/sessions/${profileID}/${sessionID}/${gender}/right_img`,
                                        )
                                    }
                                >
                                    <span className="flex items-center gap-2">
                                        Continue <ChevronForwardIcon size={18} />
                                    </span>
                                </ActionButton>
                            ) : (
                                <ActionButton
                                    variant="primary"
                                    className="flex items-center gap-2 px-5 py-3 text-sm"
                                    onClick={() => {
                                        optimizeImages();
                                        history.push(
                                            `/sessions/${profileID}/${sessionID}/${gender}/result`,
                                        );
                                    }}
                                >
                                    <span className="flex items-center gap-2">
                                        See results <ChevronForwardIcon size={18} />
                                    </span>
                                </ActionButton>
                            ))}
                    </div>
                </div>
            )}
        </CaptureScreen>
    );
};

export default PhotoCapture;
